import React, { useState } from "react";

import { COLOR_VALUES } from "shared/config/colors";
import HStack from "shared/components/layout/stack/HStack";
import Table from "shared/components/data-display/tables/Table";
import TableFilters from "shared/components/data-display/tables/TableFilters";
import TertiaryButton from "shared/components/inputs/button/TertiaryButton";
import { getCellWidthInPercent } from "features/admin/clients/ClientsTable";
import useClientRateCards from "features/admin/clients/single/useClientRateCards";

const Table_Width = 640;

const columns = [
    {
        headCellProps: {
            text: "ID",
            width: getCellWidthInPercent(72, Table_Width),
        },

        getBodyCellProps: (cell) => ({
            text: cell.value,
        }),
        filter: (rows, _columnIds, filterValue) => {
            return rows?.filter((row) => {
                return (
                    (filterValue === "active" &&
                        row.values.UseAsDefault === true) ||
                    (filterValue === "inactive" &&
                        row.values.UseAsDefault === false)
                );
            });
        },
        accessor: "RateCardTableId",
    },
    {
        headCellProps: {
            text: "Card",
            width: getCellWidthInPercent(326, Table_Width),
        },
        getBodyCellProps: (cell) => ({
            text: cell.value ?? "-",
        }),
        accessor: "RateCardTableName",
    },
    {
        headCellProps: {
            text: "Default",
            width: getCellWidthInPercent(80, Table_Width),
            centered: true,
        },
        sortType: "basic",
        getBodyCellProps: (cell) => ({
            icon: cell.value ? "toggle-true" : "toggle-false",
            iconWidth: 32,
            iconHeight: 16,
            iconViewBox: `0 0 32 16`,
        }),
        accessor: "UseAsDefault",
    },
    {
        headCellProps: {
            width: getCellWidthInPercent(100),
        },
        accessor: "Active",
        disableSortBy: true,
        getBodyCellProps: (cell) => ({
            shownByRowHover: true,
            actionIcon: "edit",
            actionProps: {
                to: `?action=editRateCard&id=${cell.row.original.RateCardTableId}`,
                replace: true,
                "aria-label": "Edit",
            },
        }),
    },
];

const FiltersConfig = [
    {
        name: "active",
        columnAccessor: "RateCardTableId",
        unfilteredValue: "all",
        isSegmentedControl: true,
        options: [
            {
                value: "all",
                label: "All",
            },
            {
                value: "active",
                label: "Default",
            },
            {
                value: "inactive",
                label: "Non Default",
            },
        ],
    },
];

const tableCTAProps = {
    leadingIcon: "expand",
    label: "Add",
    to: "?action=addRateCard",
    replace: true,
};

const getRowProps = (row) => ({
    style: {
        background:
            row.values.UseAsDefault === false ? COLOR_VALUES.Gray_9 : "",
    },
});

const ClientRateCardsTable = () => {
    const [filters, setFilters] = useState();

    const { clientRateCards } = useClientRateCards();

    if (clientRateCards.isLoading) {
        return <>Loading...</>;
    }

    if (clientRateCards.isError) {
        return <>Error</>;
    }

    return (
        <>
            <HStack align="end" justify="space-between">
                <TableFilters
                    filtersConfig={FiltersConfig}
                    onChange={setFilters}
                />
                <TertiaryButton {...tableCTAProps} />
            </HStack>
            <Table
                columns={columns}
                data={clientRateCards?.data}
                filters={filters}
                emptyActionProps={tableCTAProps}
                emptyMessageTableTitle={"Rate Cards"}
                getRowProps={getRowProps}
            />
        </>
    );
};

export default React.memo(ClientRateCardsTable);
